var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCascadeGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.738281 0.952567C0.738281 0.558078 1.05808 0.238281 1.45257 0.238281H9.07161C9.4661 0.238281 9.7859 0.558078 9.7859 0.952567V8.57161C9.7859 8.9661 9.4661 9.2859 9.07161 9.2859H1.45257C1.05808 9.2859 0.738281 8.9661 0.738281 8.57161V0.952567ZM2.16685 1.66685V7.85733H8.35733V1.66685H2.16685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2148 11.4291C11.2148 11.0346 11.5346 10.7148 11.9291 10.7148H19.5482C19.9427 10.7148 20.2625 11.0346 20.2625 11.4291V19.0482C20.2625 19.4427 19.9427 19.7625 19.5482 19.7625H11.9291C11.5346 19.7625 11.2148 19.4427 11.2148 19.0482V11.4291ZM12.6434 12.1434V18.3339H18.8339V12.1434H12.6434Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78516 9.04688H5.73754V15.7135H11.928V16.6659H5.78516C5.23287 16.6659 4.78516 16.2182 4.78516 15.6659V9.04688Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCascadeGoal);
export default __webpack_public_path__ + "static/media/cascade-goal.8b6ea86863189867dd654935bebced8f.svg";
export { ForwardRef as ReactComponent };